import { Bell, Moon, Sun, SunMoon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/atoms/Logo";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/atoms/Avatar";
import { useAuth } from "@/contexts/AuthContext";
import { useTheme } from "@/contexts/ThemeContext";
import { ROUTES } from "@/constants/routes";

const THEME_CYCLE = ["light", "dark", "system"] as const;
const THEME_ICON = { light: Sun, dark: Moon, system: SunMoon };

export function Header() {
  const { profile } = useAuth();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();

  const ThemeIcon = THEME_ICON[theme];

  function cycleTheme() {
    const currentIndex = THEME_CYCLE.indexOf(theme);
    const next = THEME_CYCLE[(currentIndex + 1) % THEME_CYCLE.length]!;
    setTheme(next);
  }

  const firstName = profile?.nome?.split(" ")[0] ?? "";

  return (
    <header className="safe-top sticky top-0 z-40 glass">
      <div className="container flex h-16 items-center justify-between">
        <button onClick={() => navigate(ROUTES.home)} className="flex items-center" aria-label="Ir para a Home">
          <Logo />
        </button>

        <div className="flex items-center gap-2">
          <button
            onClick={cycleTheme}
            aria-label={`Tema atual: ${theme}. Alternar tema.`}
            title={`Tema: ${theme === "light" ? "Claro" : theme === "dark" ? "Escuro" : "Automático"}`}
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-border bg-surface-elevated text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <ThemeIcon className="h-4 w-4" />
          </button>

          <button
            onClick={() => navigate(ROUTES.notifications)}
            aria-label="Notificações"
            className="relative flex h-9 w-9 items-center justify-center rounded-xl border border-border bg-surface-elevated text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Bell className="h-4 w-4" />
          </button>

          <button
            onClick={() => navigate(ROUTES.profile)}
            className="ml-0.5 rounded-full ring-2 ring-primary/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            aria-label="Meu perfil"
          >
            <Avatar size="sm">
              <AvatarImage src={profile?.foto ?? undefined} alt={profile?.nome ?? "Usuário"} />
              <AvatarFallback>{firstName.charAt(0).toLocaleUpperCase() || "P"}</AvatarFallback>
            </Avatar>
          </button>
        </div>
      </div>
    </header>
  );
}
